import { render } from "./editPyramide.vue?vue&type=template&id=42bcf10f"
import script from "./editPyramide.vue?vue&type=script&lang=js"
export * from "./editPyramide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__